import { usePostMutation } from "@/api/swr/useMutation";
import { fileDownloadSchema } from "@/schema/FileDownload";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<z.ZodUndefined, typeof fileDownloadSchema>
>[3];

export function useDownloadFile(path: string, config?: Config) {
  return usePostMutation(
    z.undefined(),
    fileDownloadSchema,
    `/file/${path}`,
    config,
  );
}
